var incomingData = {};
angular.module('a3modal', ['ui.bootstrap', 'angularutilities', 'pascalprecht.translate', 'ngTable', 'embeddedMetricCharts', 'sharedInitiatives', 'app.core'])

.config(function($sceProvider, $httpProvider) {
	$sceProvider.enabled(false);
	if (!$httpProvider.defaults.headers.get){
		$httpProvider.defaults.headers.get = {};
	}
	$httpProvider.defaults.headers.get['If-Modified-Since'] = '0';
})

.service('a3modalService', function($http, hostUrl) {
	var urlPfx = '2/factndx/';
	return {
		getStartAndEndDates:getStartAndEndDates
	};
	
	function getStartAndEndDates() {
		var url = urlPfx + globalConfig.factory.id +'/FactoryControlVariables/FactoryMetricDateRange';
		return $http.get(hostUrl + url)
		.then(getStartAndEndDatesComplete)
		.catch(getStartAndEndDatesFailed);
	
		function getStartAndEndDatesComplete(response){
			return response.data;
		}
		
		function getStartAndEndDatesFailed(error) {
			return undefined;
		}
	}
})

.controller('a3modalCtrl', function($scope, $uibModal, $timeout, a3modalService) {
	var loadingDates = false;
	function populateDates() {
		a3modalService.getStartAndEndDates()
		.then(function(data){
			incomingData['beginDate'] = data.startDate;
			incomingData['endDate'] = data.endDate;
			loadingDates = false;
		});
	}
	
	$scope.openModalReport = function(metricNdx, metricName, workcenterNdx, workcenterName, initiativeVs){
    	var reportScope = $scope.$new();
    	reportScope.isEmbedded = true;
    	incomingData.metricNdx = metricNdx;
    	incomingData.vsNdx = workcenterNdx;
    	incomingData.metricName = metricName;        
    	incomingData.vsList = [];
    	incomingData.initVsList = initiativeVs;
    	incomingData.vsList.push(workcenterNdx);
    	reportScope.selectedVstreamNames = workcenterName;
    	reportScope.mtrcName = metricName;
    	if (!reportScope.selectedVstreamNames || reportScope.selectedVstreamNames === ''){
    		reportScope.selectedVstreamNames = 'Plant Wide';
    	}
    	var instance;
    	if (incomingData.beginDate){
	    	instance = $uibModal.open({
				scope: reportScope,
				templateUrl: '/application/f/dashboard/widgets/a3metric.html',
				windowTemplateUrl: '/application/f/dashboard/widgets/a3metric-template.html'
			});
	    	instance.result.then(function() {
				//do nothing on success
			}, function() {
				reportScope.closeDialog();
			});
    	} else if (!loadingDates){
    		loadingDates = true;
    		populateDates();
    		$timeout(function() {
    			$scope.openModalReport(metricNdx, metricName,  workcenterNdx, workcenterName);
    		}, 10);
    	} else {
    		$timeout(function() {
    			$scope.openModalReport(metricNdx, metricName,  workcenterNdx, workcenterName);
    		}, 10);
    	}
		
		reportScope.closeDialog = function(){
			incomingData = {};
			instance.close();
			reportScope.$destroy();
			
		};
	};
})
;